const SkeletonCard = () => {
  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 px-4 md:px-12 gap-4">
        <div>
          <div className="animate-pulse rounded w-full aspect-square md:aspect-video bg-slate-200"></div>
          <div className="animate-pulse w-full h-3 bg-slate-200 mt-2"></div>
          <div className="animate-pulse w-[80%] h-3 bg-slate-200 mt-1"></div>
          <div className="animate-pulse w-[60%] h-3 bg-slate-200 mt-1"></div>
          <div className="animate-pulse w-[20%] h-3 bg-slate-200 mt-1"></div>
        </div>
        <div>
          <div className="animate-pulse rounded w-full aspect-square md:aspect-video bg-slate-200"></div>
          <div className="animate-pulse w-full h-3 bg-slate-200 mt-2"></div>
          <div className="animate-pulse w-[80%] h-3 bg-slate-200 mt-1"></div>
          <div className="animate-pulse w-[60%] h-3 bg-slate-200 mt-1"></div>
          <div className="animate-pulse w-[20%] h-3 bg-slate-200 mt-1"></div>
        </div>
        <div>
          <div className="animate-pulse rounded w-full aspect-square md:aspect-video bg-slate-200"></div>
          <div className="animate-pulse w-full h-3 bg-slate-200 mt-2"></div>
          <div className="animate-pulse w-[80%] h-3 bg-slate-200 mt-1"></div>
          <div className="animate-pulse w-[60%] h-3 bg-slate-200 mt-1"></div>
          <div className="animate-pulse w-[20%] h-3 bg-slate-200 mt-1"></div>
        </div>
        <div>
          <div className="animate-pulse rounded w-full aspect-square md:aspect-video bg-slate-200"></div>
          <div className="animate-pulse w-full h-3 bg-slate-200 mt-2"></div>
          <div className="animate-pulse w-[80%] h-3 bg-slate-200 mt-1"></div>
          <div className="animate-pulse w-[60%] h-3 bg-slate-200 mt-1"></div>
          <div className="animate-pulse w-[20%] h-3 bg-slate-200 mt-1"></div>
        </div>
      </div>
  );
};

export default SkeletonCard;
